module.exports = __webpack_public_path__ + "20250721160708/img/train.fad4e939.png";